<template>
  <th :style="styles" :class="column.head_class || ''">
    <slot>
      {{ label }}
    </slot>
  </th>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    column: Object,
  },
  computed: {
    label() {
      if (typeof this.column.label !== 'undefined') return this.column.label;

      const column = { ...this.column };

      return column.key.charAt(0).toUpperCase() + column.key.slice(1);
    },
    tieneWidth() {
      return !!this.column?.width;
    },
    styles() {
      if (!this.tieneWidth) {
        return {
          width: this.width < this.breakpoints.MD ? "150px" : "100%",
        };
      }

      if (!this.esAnchoDinamico) {
        return {
          width: this.column.width + "px",
        };
      }

      let width = "100%";

      if (this.column.width?.LG && this.isLG) {
        width = this.column.width.LG + "px";
      }

      if (this.column.width?.MD && this.isMD) {
        width = this.column.width.MD + "px";
      }

      if (this.column.width?.SM && this.isSM) {
        width = this.column.width.SM + "px";
      }

      if (this.column.width?.XS && this.isXS) {
        width = this.column.width.XS + "px";
      }

      return {
        width: width,
      };
    },
    esAnchoDinamico() {
      return typeof (this.column?.width || "") === "object";
    },
    ...mapState("window", ["width", "breakpoints"]),
    ...mapGetters("window", ["isXS", "isSM", "isMD", "isLG"]),
  },
};
</script>
